import { Stack, Typography, useTheme } from "@mui/material";
import type { RentDrawdownMode } from "web_myplann/Goals/Forms/useGoalForm";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LabeledValueRow } from "web_myplann/Shared/Components/LabeledValueRow";

type Props = {
	totalValue: number;
	drawdownMode: RentDrawdownMode;
	rentYears: number;
	currencySuffix: string;
};

export const RentTotalRow: React.FC<Props> = ({
	totalValue,
	drawdownMode,
	rentYears,
	currencySuffix,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	const isPerpetual = drawdownMode === "perpetual";

	return (
		<Stack
			px={1.6}
			py={1.5}
			borderTop={1}
			borderColor="surface.border"
			bgcolor={theme.palette.surface.muted}
			gap={0.6}
		>
			<LabeledValueRow
				label={
					<Typography variant="body1" color={theme.palette.grey[600]}>
						{isPerpetual
							? t(Resources.Goals.Form.Pension.totalLabelPerpetual)
							: t(Resources.Goals.Form.Pension.totalLabelToZero)}
					</Typography>
				}
				value={
					<Typography variant="bodyStrong" tabular>
						{totalValue.toLocaleString("cs-CZ")} {currencySuffix}
					</Typography>
				}
			/>
			<Typography variant="caption" color={theme.palette.grey[500]}>
				{isPerpetual
					? t(Resources.Goals.Form.Pension.totalDescriptionPerpetual, {
							years: rentYears || "?",
						})
					: t(Resources.Goals.Form.Pension.totalDescriptionToZero, {
							years: rentYears || "?",
						})}
			</Typography>
		</Stack>
	);
};
